import { render, staticRenderFns } from "./outdatedBrowser.vue?vue&type=template&id=0a75619f&scoped=true"
import script from "./outdatedBrowser.vue?vue&type=script&lang=js"
export * from "./outdatedBrowser.vue?vue&type=script&lang=js"
import style0 from "./outdatedBrowser.vue?vue&type=style&index=0&id=0a75619f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a75619f",
  null
  
)

export default component.exports